import Academy from './academy';

declare global {
	interface Window { Elibrary: Academy; }
}

window.Elibrary = Academy;

document.addEventListener('DOMContentLoaded', () => {
	const questionCollapse = document.querySelector('.question-list-wrap');

	if (questionCollapse) {
		questionCollapse.addEventListener('show.bs.collapse', e => {
			const icon = document.querySelector('.question-collapser i');
			icon.classList.replace('fa-plus', 'fa-minus');
		});
		questionCollapse.addEventListener('hide.bs.collapse', e => {
			const icon = document.querySelector('.question-collapser i');
			icon.classList.replace('fa-minus', 'fa-plus');
		});
	}
});

document.addEventListener('DOMContentLoaded', () => {
	const mobile_detect = document.querySelector('#mobile-detect');
	const is_mobile = mobile_detect ? getComputedStyle(mobile_detect).display === 'none' : null;

	if (is_mobile) {
		document.querySelector('.filter-list.collapse').classList.remove('show');
		jQuery('.filter-list.collapse').collapse('hide');
		document.querySelector('.filter-collapser i').classList.replace('fa-minus', 'fa-plus');
		document.querySelector('.question-list-wrap').classList.remove('show');
		jQuery('.question-list-wrap').collapse('hide');
		document.querySelector('.question-collapser i').classList.replace('fa-minus', 'fa-plus');
	}
});
